// Global loading state manager
class LoadingManager {
    private static instance: LoadingManager;
    private loadingCount = 0;
    private subscriber?: () => void;

    static getInstance(): LoadingManager {
        if (!LoadingManager.instance) {
            LoadingManager.instance = new LoadingManager();
        }
        return LoadingManager.instance;
    }

    addLoader(): void {
        this.loadingCount++;
        this.notifySubscriber();
    }

    removeLoader(): void {
        this.loadingCount = Math.max(0, this.loadingCount - 1);
        this.notifySubscriber();
    }

    isLoading(): boolean {
        return this.loadingCount > 0;
    }

    getLoadingCount(): number {
        return this.loadingCount;
    }

    subscribe(callback: () => void): () => void {
        this.subscriber = callback;
        return () => {
            this.subscriber = undefined;
        };
    }

    private notifySubscriber(): void {
        this.subscriber?.();
    }
}

export default LoadingManager;
